import { Inject } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { RegionService } from "app/shared/services/region.service";
import { Region } from "app/shared/models/region.interface";

export class RegionsResolver implements Resolve<Region[]> {
  constructor(@Inject(RegionService) private service: RegionService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Region[]> {
    return this.service.getRegions();
  }
}
